import "./style.css";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience.jsx";

function App() {
    return (
        <>
            <Canvas
                camera={{
                    fov: 45,
                    near: 0.1,
                    far: 200,
                    position: [0, 0, 0],
                }}
                style={{ position: "absolute", top: 0, left: 0, zIndex: -1 }}
            >
                <Experience />
            </Canvas>

            <div className="overlay">
                <div className="top-nav">
                    <div className="logo">
                        <svg viewBox="0 0 100 100" fill="currentColor">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 0 H100 V100 H0 Z M34 34 H66 V66 H34 Z"
                            />
                        </svg>
                    </div>
                    <div className="nav-links">
                        <a className="nav-link" href="/about">
                            About
                        </a>
                        <a className="nav-link" href="/contact">
                            Contact
                        </a>
                    </div>
                </div>

                <div className="hero">
                    <h1>
                        Make
                        <br />
                        Transparency
                        <br />
                        Accessible
                        <br />
                        to Everyone
                    </h1>
                </div>
            </div>
        </>
    );
}

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(<App />);
